import {UrmProgramCompilingError, UrmProgramCompilingException} from "../../errors/Exceptions";
import {UrmCommand, UrmCommandType} from "./UrmCommand";
import {UrmProgram} from "./UrmProgram";


const URM_COMMAND_REGEX = /^\d+\)((Z\(\d+\))|(S\(\d+\))|(T\(\d+,\d+\))|(J\(\d+,\d+,\d+\)))$/;

export class UrmProgramParser{

    /**
     *
     * @param str is program as string
     * @returns {UrmProgram}
     */
    static parse(str){
        // break on lines by \n
        let lines = str.split('\n');

        // don't consider comments: in each line delete symbols starting from //
        lines = lines.map((l) => l.split("//")[0]);

        // remove all whitespace from each line
        lines = lines.map((l) => l.replace(/\s/g,''));


        // check for syntax errors: check if each non-empty line matches regex
        let syntaxErrors = [];
        lines.forEach((line, idx) => {
            if(line !== '' && !URM_COMMAND_REGEX.test(line)){
                syntaxErrors.push(new UrmProgramCompilingError(idx,'Incorrect syntax for URM command'));
            }
        });
        if(syntaxErrors.length > 0){
            throw new UrmProgramCompilingException(syntaxErrors, "Invalid syntax for URM program");
        }

        // note, each numerical value is >=0 because of regex (minus char is not accepted)
        // also each operation has correct number of arguments

        // check for semantic errors, create UrmCommand objects

        // Go through each command, check its semantic and accumulate commands (and errors);
        // if at least one error is present, accumulating of commands is stopped
        let semanticErrors = [];
        let expectedCommandIndex = 1;
        let commands = []; // array of UrmCommand objects
        for(let i = 0; i < lines.length; i++){
            let line = lines[i];
            if(line !== ''){
                let commandTypeStr = line.match(/[ZSTJ]/g)[0];
                let commandType = UrmCommandType.fromString(commandTypeStr);

                let integersInLine = line.match(/\d+/g)
                    .map((i) => parseInt(i));

                let commandIndex = integersInLine[0];
                let args = [...integersInLine].slice(1); // all but first element


                if(commandType === UrmCommandType.J){
                    if(args[2] < 1){
                        semanticErrors.push(new UrmProgramCompilingError(
                            i, "3rd arg of J command must be greater or equal than 1"));
                    }
                }

                // check incremental consequence of indices of commands
                if(commandIndex !== expectedCommandIndex){
                    let errorText;
                    if(expectedCommandIndex === 1){
                        errorText = "expected index 1 for the first command";
                    }
                    else{
                        errorText = `commands indices must be incrementally consequent: expected index ${expectedCommandIndex}`;
                    }

                    semanticErrors.push(new UrmProgramCompilingError(i, errorText));
                }

                if(semanticErrors.length === 0){
                    commands.push(new UrmCommand(commandType, args)); // <---------- URM command is created here
                }
                expectedCommandIndex++;
            }
        }
        if(semanticErrors.length > 0){
            throw new UrmProgramCompilingException(semanticErrors, "Invalid semantic for URM program");
        }

        if(commands.length === 0 && semanticErrors.length === 0){ // no command is detected
            throw new UrmProgramCompilingException(
                [new UrmProgramCompilingError(-1, "URM program can't be empty")],
                "");
        }

        return new UrmProgram(commands);
    }
}